import "./Toolbar.scss"
import Button from "../../Button/Button";
import Icon, {
    alignTextCenterIcon,
    alignTextJustifyIcon,
    alignTextLeftIcon,
    alignTextRightIcon, formatBoldIcon, formatColorIcon, formatItalicIcon,
    formatListBulletedIcon, formatListNumberedIcon, formatUnderlineIcon, indentIcon,
    lineHeightIcon
} from "../../Icon/Icon";
import classNames from "classnames";
import LineHeightPicker from "./lineHeightPicker/LineHeightPicker";
import ToolbarModal from "./ToolbarModal";
import {useState} from "react";
import {getLineHeight} from "../../../utils/Utils";
import Input from "../../Input/Input";

const icons = {
    'justify': alignTextJustifyIcon,
    'left': alignTextLeftIcon,
    'center': alignTextCenterIcon,
    'right': alignTextRightIcon,
}

const fontStyleConfig = {
    bold: {
        icon: formatBoldIcon,
        command: "toggleBold"
    },
    italic: {
        icon: formatItalicIcon,
        command: "toggleItalic"
    },
    underline: {
        icon: formatUnderlineIcon,
        command: "toggleUnderline"
    },
    bulletList: {
        icon: formatListBulletedIcon,
        command: "toggleBulletList"
    },
    orderedList: {
        icon: formatListNumberedIcon,
        command: "toggleOrderedList"
    }
};

const Toolbar = ({editor}) => {
    const [toolbarModal, setToolbarModal] = useState(false);
    const [colorModal, setColorModal] = useState(false);

    return (
        <div className="toolbar-wrapper">
            <div className="toolbar">
                <div className="section">
                    {
                        ['justify', 'left', 'center', 'right'].map((alignment, index) => {
                            const isActive = editor.isActive(alignment);

                            return (
                                <Button
                                    key={index}
                                    className={classNames({active: isActive})}
                                    onClick={() => editor.chain().focus().setTextAlign(alignment).run()}
                                >
                                    <Icon svg={icons[alignment]} />
                                </Button>
                            )
                        })
                    }
                </div>

                <div className="section">
                    <div style={{position: "relative"}}>
                        <Button onClick={() => setToolbarModal(true)}>
                            <Icon svg={lineHeightIcon}/>
                        </Button>

                        {
                            toolbarModal &&
                            <ToolbarModal
                                className="line-height-picker"
                                setIsOpen={setToolbarModal}
                                onClose={() => setToolbarModal(false)}
                            >
                                <LineHeightPicker
                                    currentLineHeight={getLineHeight(editor)}
                                    onClick={(lineHeight) => editor.chain().focus().setLineHeight(lineHeight).run()}
                                />
                            </ToolbarModal>
                        }
                    </div>

                    <Button onClick={() => editor.chain().focus().indentOut().run()}>
                        <Icon svg={indentIcon}  style={{transform: "rotate(180deg)"}}/>
                    </Button>

                    <Button onClick={() => editor.chain().focus().indentIn().run()}>
                        <Icon svg={indentIcon}/>
                    </Button>
                </div>

                <div className="section">
                    <div style={{position: "relative"}}>
                        <Button onClick={() => setColorModal(true)}>
                            <Icon svg={formatColorIcon} style={{color: editor.getAttributes("textStyle").color}}/>
                        </Button>

                        {
                            colorModal &&
                            <ToolbarModal
                                className="color-picker"
                                onClose={() => setColorModal(false)}
                            >
                                <Input
                                    type="color"
                                    required={false}
                                    value={editor.getAttributes("textStyle").color}
                                    onChange={(color) => editor.chain().setColor(color).run()}
                                />
                            </ToolbarModal>
                        }
                    </div>

                    {
                        ['bold', 'italic', 'underline', 'orderedList', 'bulletList'].map((fontStyle, index) => {
                            const {icon, command} = fontStyleConfig[fontStyle];

                            return (
                                <Button
                                    key={index}
                                    onClick={() => editor.chain().focus()[command]().run()}
                                    className={classNames({active: editor.isActive(fontStyle)})}
                                >
                                    <Icon svg={icon}/>
                                </Button>
                            )
                        })
                    }

                    <div style={{position: "relative"}}>
                        {/*<Button onClick={() => setOpenTableModal(true)}>*/}
                        {/*    <TableIcon/>*/}
                        {/*</Button>*/}

                        {/*<ToolbarModal className="table-toolbar-modal" isOpen={openTableModal} setIsOpen={setOpenTableModal}>*/}
                        {/*    <TablePicker onInsertTable={(row, col) => editor.chain().focus().insertTable({*/}
                        {/*        rows: row,*/}
                        {/*        cols: col*/}
                        {/*    }).run()}/>*/}
                        {/*</ToolbarModal>*/}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Toolbar;